module.exports = __webpack_public_path__ + "img/file-pdf.fdbb9ae7.png";